// @unocss-include
import { get } from 'lodash-es'
import { ElTag } from 'element-plus'
import * as constants from './values'

type Keys = keyof typeof constants

type _U<T extends Keys> = `${T}.${string}` | T

type ConstantKeys = _U<Keys>

const tagTypes = ['success', 'info', 'warning', 'danger', 'primary']

export const _ = constants

export function k2v(constantObj: any, key: string) {
  return constantObj.find(([k, _v]: any[]) => k === key)?.[1] || key
}

export function v2k(constantObj: any, value: string) {
  return constantObj.find(([_k, v]: any[]) => v === value)?.[0] || value
}

export function v2tag(constantObj: any, value: string) {
  const constantIndex = constantObj.findIndex(([k]) => k === value)
  const constantItem = constantObj[constantIndex]
  const tagType = constantItem?.[2] || tagTypes[constantIndex % tagTypes.length]
  const tagValue = constantItem?.[1] || value
  return h(ElTag, { type: tagType as any }, () => tagValue)
}

export function tagValueForm(constantKey: ConstantKeys, key: string) {
  const constantObj = get(constants, constantKey)
  return k2v(constantObj, key)
}

export function tagForm(constantKey: ConstantKeys, value: string | number) {
  const constantObj = get(constants, constantKey)
  return v2tag(constantObj, value.toString())
}

export default {
  _,
  k2v,
  v2k,
  v2tag,
}
